import Pusher from 'pusher-js'

import { user } from 'legacy/utils/user'

export function getPusher() {
  if (!process.env.REACT_APP_PUSHER_KEY) return null

  const token = user.get('token')

  return new Pusher(process.env.REACT_APP_PUSHER_KEY, {
    cluster: 'mt1',
    authEndpoint: `${process.env.REACT_APP_API_URL}api/v2/loadboard/websockets/auth`,
    auth: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  })
}
